import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchOrganisatiesByGebied,
  initialState,
} from '../services/fetchOrganisatiesByGebied'

export { useOrganisatiesByGebied }

const queryKey = 'organisaties'

const useOrganisatiesByGebied = ({ gebiedscode }: { gebiedscode: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isPending: isLoading } = useQuery({
    queryFn: () => fetchOrganisatiesByGebied(gebiedscode),
    queryKey: [queryKey, gebiedscode],
    enabled: hasPermissions && !!gebiedscode,
  })

  return {
    data: data || initialState.data,
    isLoading,
  }
}
